import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { API_BASE_URL, ENDPOINTS } from '../../config';
import { useAuth } from '../hooks/useAuth';
import 'notyf/notyf.min.css';
import { Notyf } from 'notyf';
import { Link } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "<YOUR_MICROSOFT_CLIENT_ID>",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
  },
};
const msalInstance = new PublicClientApplication(msalConfig);
const notyf = new Notyf({
  position: {
    x: 'right',
    y: 'top'
  },
  ripple: true,
  dismissible: true,
});
const Login = () => {
  const [email, setEmail] = useState('voiceboat@voiceboat.com');
  const [password, setPassword] = useState('Voiceboat@123');
  const [error, setError] = useState('');
  const [, setCookie] = useCookies(['token']);
  const navigate = useNavigate();

  // const { checkAndRedirect } = useAuth();
  // useEffect(() => {
  //   if (checkAndRedirect()) {
  //    // notyf.info('You are already logged in');
  //   }
  // }, [checkAndRedirect]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('username', email);
      formData.append('password', password);

      const response = await axios.post(
        `${API_BASE_URL}${ENDPOINTS.AUTH.PASS_Login}`,
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );

      setCookie('token', response.data.access_token, {
        path: '/',
        secure: true,
        sameSite: 'strict',
        maxAge: 24 * 60 * 60,
      });


      const responser = await axios.get(
        `${API_BASE_URL}${ENDPOINTS.CHATS.GET_ALL}`,
        {
          headers: {
            Authorization: `Bearer ${response.data.access_token}`
          }
        }
      );

      if (!responser.data[0]) {
        const responseD = await axios.post(
          `${API_BASE_URL}${ENDPOINTS.CHATS.CREATE}`,
          { title: "Ask Me Anything", messages: [{ content: '', sender: '' }] },
          { headers: { Authorization: `Bearer ${response.data.access_token}` } }
        );
        navigate(`/c/${responseD.data.chat_id}`);
      } else {
        navigate(`/c/${responser.data[0].chat_id}`);
      }
      // navigate(`/c/${responseD.data.chat_id}`);

      //setCookie('token', response.data.access_token, { path: '/' });
      //navigate('/');
      notyf.success('Login successful!');
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Login failed';
      setError(errorMessage);
      notyf.error(errorMessage);
    }
  };

  const handleGoogleSuccess = async (response) => {
    console.log("Google login success", response);
    const googleToken = response.credential; // Google OAuth token

    try {
      const googleAuthResponse = await axios.post(
        `${API_BASE_URL}${ENDPOINTS.AUTH.LOGIN}`,
        { token: googleToken, provider: "google" },
        { headers: { 'Content-Type': 'application/json' } }
      );

      setCookie('token', googleAuthResponse.data.access_token, {
        path: '/',
        secure: true,
        sameSite: 'strict',
        maxAge: 24 * 60 * 60,
      });

      const chatResponse = await axios.get(
        `${API_BASE_URL}${ENDPOINTS.CHATS.GET_ALL}`,
        {
          headers: { Authorization: `Bearer ${googleAuthResponse.data.access_token}` },
        }
      );

      if (!chatResponse.data[0]) {
        const newChat = await axios.post(
          `${API_BASE_URL}${ENDPOINTS.CHATS.CREATE}`,
          { title: 'Ask Me Anything', messages: [{ content: '', sender: '' }] },
          { headers: { Authorization: `Bearer ${googleAuthResponse.data.access_token}` } }
        );
        navigate(`/c/${newChat.data.chat_id}`);
      } else {
        navigate(`/c/${chatResponse.data[0].chat_id}`);
      }

      notyf.success('Google login successful!');
    } catch (error) {
      console.log(error)
      const errorMessage = error.response?.data?.detail || 'Google login failed';
      setError(errorMessage);
      notyf.error(errorMessage);
    }
  };
  const handleMicrosoftLogin = async () => {
    try {
      const loginResponse = await msalInstance.loginPopup({
        scopes: ["user.read"], // Needed for Graph API
      });

      const msToken = loginResponse.accessToken;

      // Send Microsoft token to backend
      const msAuthResponse = await axios.post(
        `${API_BASE_URL}${ENDPOINTS.AUTH.LOGIN}`,
        { token: msToken, provider: "microsoft" },  // 👈 same format as Google
        { headers: { "Content-Type": "application/json" } }
      );

      // Save JWT
      setCookie("token", msAuthResponse.data.access_token, {
        path: "/",
        secure: true,
        sameSite: "strict",
        maxAge: 24 * 60 * 60,
      });

      // Fetch chats
      const chatResponse = await axios.get(
        `${API_BASE_URL}${ENDPOINTS.CHATS.GET_ALL}`,
        {
          headers: {
            Authorization: `Bearer ${msAuthResponse.data.access_token}`,
          },
        }
      );

      if (!chatResponse.data[0]) {
        const newChat = await axios.post(
          `${API_BASE_URL}${ENDPOINTS.CHATS.CREATE}`,
          { title: "Ask Me Anything", messages: [{ content: "", sender: "" }] },
          { headers: { Authorization: `Bearer ${msAuthResponse.data.access_token}` } }
        );
        navigate(`/c/${newChat.data.chat_id}`);
      } else {
        navigate(`/c/${chatResponse.data[0].chat_id}`);
      }

      notyf.success("Microsoft login successful!");
    } catch (err) {
      console.error("Microsoft login failed", err);
      notyf.error("Microsoft login failed. Please try again.");
    }
  };
  // Handle Google login failure
  const handleGoogleFailure = (error) => {
    console.error('Google login failed:', error);
    setError('Google login failed. Please try again.');
    notyf.error('Google login failed. Please try again.');
  };

  return (
    <>

      <div className="auth-body login">
        <div className="auth-background">
          <div className="bg-pattern"></div>
          <div className="floating-elements">
            <div className="floating-element"><i className="fas fa-brain"></i></div>
            <div className="floating-element"><i className="fas fa-robot"></i></div>
            <div className="floating-element"><i className="fas fa-chart-line"></i></div>
            <div className="floating-element"><i className="fas fa-image"></i></div>
          </div>
        </div>
        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-header">
              <div className="brand-logo">
                <h1><img src="assets/img/hola.png" alt="" className="logo" /></h1>
              </div>
              <p>Sign in to access your AI dashboard</p>
            </div>
            {error && <p className="error">{error}</p>}
            <form className="auth-login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fas fa-envelope"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fas fa-lock"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength="8"
                    autoComplete="off"
                  />
                  <button type="button" className="password-toggle">
                    <i className="fas fa-eye"></i>
                  </button>
                </div>
              </div>

              <div className="form-check-row">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="remember" />
                  <label className="form-check-label" for="remember">
                    Remember me
                  </label>
                </div>
                <a href="#" className="forgot-link">Forgot password?</a>
              </div>

              <button type="submit" className="btn btn-primary btn-auth">
                <i className="fas fa-sign-in-alt"></i>
                Sign In
              </button>
            </form>
            <div className="auth-divider">
              <span>or continue with</span>
            </div>
            <div className="social-auth">
              <button className="social-btn">
                {/* <i className="fab fa-google"></i>
                Continue with Google */}
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleGoogleFailure}
                />
              </button>
              <button onClick={handleMicrosoftLogin} className="social-btn">
                <i className="fab fa-microsoft"></i> Continue with Microsoft
              </button>
            </div>
            <div className="auth-footer">
              Don't have an account?
              <Link to="/registration">Sign Up Now</Link>
            </div>
          </div>
        </div>
      </div>


      {/* <div className="login-container">
      <form>
        <h2>HolaAI Login</h2>
        
        
        
        
      </form>
    </div> */}
    </>
  );
};

export default Login;